module.exports = __webpack_public_path__ + "static/media/login-img.cd7bd48c.png";